import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState, Form } from '@common/components';
import { Select } from 'antd';
import { ENUM_QUERY } from '@common/graphql';

const licenseTypesWeight = {
  registered: 1,
  practical: 2,
  practitioner: 3,
  nursing_assistant: 4,
  midwife: 5,
  anesthetist: 6,
  clinical: 7,
  certified_athletic_trainer: 8,
  occupational_therapist: 9,
  occupational_therapist_assistant: 10,
  physical_therapist: 11,
  physical_therapist_assistant: 12,
  audiologist: 13,
  certified_respiratory_therapist: 14,
  speech_language_pathologist: 15,
  american_registry_of_registered_technologist: 16,
  hearing_aid_dispensing: 17,
  registered_cardiac_sonographer: 18,
  registered_congenital_cardiac_sonographer: 19,
  registered_vascular_specialist: 20,
  registered_cardiovascular_invasive_specialist: 21,
  licensed_psychiatric_technician: 22,
  medical_laboratory_scientist: 23,
  registered_dietician: 24,
  pharmacist: 25,
  pharmacy_technician: 26,
  certified_medical_dosimetrist: 27,
  licensed_clinical_social_worker: 28,
  physician_assistant_certified: 29,
};

export function LicenseTypeInput({ name, submitting }) {
  const { loading, error, data } = useQuery(ENUM_QUERY, {
    variables: { key: 'AlliedHealthNursingLicenseType' },
  });

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="LicenseTypeInput"
        messageType="contextual"
      />
    );
  }

  const enumValues = data ? [...data.enum] : [];

  const sortedData = enumValues.sort((a, b) => {
    const weightedA = licenseTypesWeight[a.name] || 100;
    const weightedB = licenseTypesWeight[b.name] || 100;

    return weightedA - weightedB;
  });

  return (
    <Form.Item
      label="License type"
      name={name}
      rules={[
        {
          required: true,
          message: 'Please enter a valid license type',
        },
      ]}
    >
      <Select size="large" disabled={submitting}>
        {sortedData.map(({ name, description }) => (
          <Select.Option key={name} value={name}>
            {description}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

LicenseTypeInput.propTypes = {
  submitting: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
